/*
 * @Author: your name
 * @Date: 2021-08-06 14:14:22
 * @LastEditTime: 2021-09-04 09:34:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /cw-bi-project-wap-h5/src/api/url.js
 */
let backUrl = {
    development: {
        // node: '//192.168.101.230:8021/api',
        node: '//p-console.algobuy.net/api',
        // node: "http://test-p-console.algobuy.net/api",
        java: "//newapi.algobuy.net",
        // java: 'http://172.28.18.83:87152
    },
    none: {
        node: "//test-p-console.algobuy.net/api",
        java: "//dev-newapi.algobuy.net",
    },
    production: {
        // node: '//bigdata-display.zhizh.com/api',
        node: "//p-console.algobuy.net/api",
        // java: 'http://bigdata-query.zhizh.com'
        java: "//newapi.algobuy.net",
    },
};
export const node_url = backUrl[process.env.NODE_ENV].node;
export const java_url = backUrl[process.env.NODE_ENV].java;
